(function() {
  'use strict';

  function updateBadge(sectionId, variantId) {
    var wrapper = document.getElementById('StockBadge-' + sectionId);
    var dataEl = document.getElementById('StockBadgeData-' + sectionId);
    if (!wrapper || !dataEl) return;

    var stockData;
    try { stockData = JSON.parse(dataEl.textContent); } catch(e) { return; }

    var v = stockData[variantId];
    if (!v || v.mgmt !== 'shopify') { wrapper.innerHTML = ''; return; }

    var qty = v.qty;
    var policy = v.policy;

    // FIRM clearance batch: qty is real (1 per shade) but the piece is NOT pre-made —
    // only the firmer first layer is poured, the rest is built after purchase. The
    // normal "Ships within 48h" wording would be a false promise, so branch out early.
    // Second batch (data-firm="ready") IS already made — "ships in 1–2 business days".
    if (wrapper.dataset.firm === 'true' || wrapper.dataset.firm === 'ready') {
      var firmWhen = wrapper.dataset.firm === 'ready'
        ? 'already made, ships in 1–2 business days'
        : 'made after purchase: 1–2 business days';
      wrapper.innerHTML = qty > 0
        ? '<span class="stock-badge stock-badge--low">' +
          '<span class="stock-badge__dot"></span>' +
          'Only ' + qty + ' left in this shade — ' + firmWhen + '</span>'
        : '<span class="stock-badge stock-badge--out-of-stock">' +
          '<span class="stock-badge__dot"></span>' +
          'Sold Out — this shade is gone</span>';
      return;
    }
    // Ready-to-ship = real stock 1..8999. 10000 = Made-to-Order placeholder, not real stock.
    // Badge keys off quantity, NOT policy: every variant is "continue" (always buyable),
    // so the badge can never disable the buy button. deny+qty<=0 (SALE only) = genuine Sold Out.
    var inStock = (qty > 0 && qty < 9000);
    var soldOut = (policy === 'deny' && qty <= 0);
    var html = '';

    if (inStock) {
      if (qty <= 5) {
        html = '<span class="stock-badge stock-badge--low">' +
               '<span class="stock-badge__dot"></span>' +
               'Only ' + qty + ' left \u2014 Ships within 48h</span>';
      } else {
        html = '<span class="stock-badge stock-badge--in-stock">' +
               '<span class="stock-badge__dot"></span>' +
               'In Stock \u2014 Ships within 48h</span>';
      }
    } else if (soldOut) {
      html = '<span class="stock-badge stock-badge--out-of-stock">' +
             '<span class="stock-badge__dot"></span>' +
             'Sold Out</span>';
    } else {
      // continue (incl. 10000 placeholder or qty<=0) \u2192 Made to Order, always purchasable
      html = '<span class="stock-badge stock-badge--made-to-order">' +
             '<span class="stock-badge__dot"></span>' +
             'Made to Order \u2014 Production: 1\u20132 business days + shipping</span>';
    }

    wrapper.innerHTML = html;
  }

  var lastVariant = null;

  function checkVariant() {
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    if (vid && vid !== lastVariant) {
      lastVariant = vid;
      document.querySelectorAll('[id^="StockBadge-"]').forEach(function(el) {
        updateBadge(el.dataset.sectionId, vid);
      });
    }
  }

  var _pushState = history.pushState;
  var _replaceState = history.replaceState;
  history.pushState = function() {
    _pushState.apply(this, arguments);
    setTimeout(checkVariant, 10);
  };
  history.replaceState = function() {
    _replaceState.apply(this, arguments);
    setTimeout(checkVariant, 10);
  };
  window.addEventListener('popstate', checkVariant);

  document.addEventListener('DOMContentLoaded', function() {
    if (typeof subscribe === 'function') {
      try {
        subscribe('variant:change', function(event) {
          if (event && event.data && event.data.variant) {
            document.querySelectorAll('[id^="StockBadge-"]').forEach(function(el) {
              updateBadge(el.dataset.sectionId, event.data.variant.id);
            });
          }
        });
      } catch(e) {}
    }

  });
})();
